<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack">
            <i class="fa fa-arrow-right"></i>
        </button>-->
                    تمدید حساب کاربری
                    <button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage">
                    <i class="font-16 fa fa-redo"></i>
                </button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2">
                <div class="content">
                    <h4 v-if="orginalpayable>0 && payable!=orginalpayable && loading==false" class="mb-3 font-16 text-center">مبلغ اشتراک: <del class="text-danger font-20">{{orginalpayable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</del></h4>
                    <h4 v-if="payable!=orginalpayable && loading==false" class="mb-3 font-16 text-center">قابل پرداخت: <b class="font-20">{{payable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</b></h4>
                    <div class="mb-3" v-html="descriptionText"></div>
                    <!--<h4 v-if="loading==false" class="mb-3 text-danger font-12 line-height-l text-center">تخفیف 15 درصدی خرید: روزهای پنج شنبه،جمعه هر ساعت از شبانه روز و سایر روزهای هفته از ساعت 21:00 لغایت 02:00 بامداد</h4>-->
                    <h4 v-if="payable===orginalpayable && loading==false" class="mb-3 font-16 text-center">قابل پرداخت: <b class="font-20">{{payable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</b></h4>
                    <h4 v-if="loading==true" class="text-danger mb-3 font-16 text-center">
                        <span class="d-flex justify-content-center w-100"><span class="spinner-border color-magenta2-dark" role="status"></span></span>
                        <b class="font-16"></b>
                    </h4>
                    <div class="divider mt-2"></div>
                    <div class="row mb-0">
                        <div class="col-12">
                            <button :disabled="payable === 0 || loading==true" class="btn btn-m mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click="sendForPayment">
                                <i class="fa fa-credit-card ml-2"></i>
                                پرداخت
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="list-group-div p-2">
                        <div class="py-2 border-b">
                            <!--<i class="fa fa-user color-blue2-dark"></i>-->
                            <img v-if="user.userImg!=null && user.userImg!=''" :src="user.userImg" alt="userProfileImg" width="40" height="40" class="rounded-circle ml-2 img-object-fit" />
                            <i v-else class="fa fa-user color-blue2-dark"></i>
                            <span class="font-weight-bold">
                                نام و نام خانوادگی:
                                <span class="font-weight-bold">{{ user.userTitle }}</span>
                            </span>
                        </div>
                        <div class="py-2 border-b" v-if="user.phoneNumber!=''">
                            <i class="fa fa-phone color-magenta2-dark"></i>
                            <span class="font-weight-bold">
                                شماره تلفن همراه:
                                <span class="font-weight-bold">{{user.phoneNumber}}</span>
                            </span>
                        </div>
                        <div class="py-2 border-b" v-if="user.emailAddress!=''">
                            <i class="fa fa-phone color-magenta2-dark"></i>
                            <span class="font-weight-bold">
                                آدرس ایمیل:
                                <span class="font-weight-bold">{{user.emailAddress}}</span>
                            </span>
                        </div>
                        <div class="py-2 border-b" v-if="user.expireDate != null">
                            <i class="fa fa-times color-red2-dark"></i>
                            <span class="font-weight-bold">
                                تاریخ انقضای فعلی:
                                <span class="d-inline-block ltr text-left mr-2">{{user.expireDate}}</span>
                            </span>
                        </div>
                        <div class="py-2 border-b">
                            <i class="fa fa-calendar color-pink2-dark"></i>
                            <span class="font-weight-bold">تعداد ماه:</span>
                            <div class="mt-1">
                                <!--<button :disabled="loading" type="button" class="btn btn-link p-0" @click="changeMonth(-1, user)">
                                    <i class="fa font-14 fa-minus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i>
                                </button>
                                <span class="font-weight-bold text-center d-inline-block" style="width: 50px">{{ user.monthCount - user.payedMonthCount }}</span>
                                <button :disabled="loading" type="button" class="btn btn-link p-0" @click="changeMonth(1, user)">
                                    <i class="fa font-14 fa-plus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i>
                                </button>-->
                                <div class="row mb-0 pr-3">
                                    <div class="col-4 d-flex align-items-center py-2 pr-0">
                                        <input class="m-0" type="radio" @change="changeMonthRadio(1, user)" :name="user.id" id="monthCount1" :checked="user.monthCount - user.payedMonthCount==1" style="width:20%;height:1.8em">
                                        <label class="mb-0 mr-2 font-14" for="monthCount1">
                                            1 ماه
                                        </label>
                                    </div>
                                    <div class="col-4 d-flex align-items-center py-2 pr-0" v-if="user.validMonthCount>=6">
                                        <input class="m-0" type="radio" @change="changeMonthRadio(6, user)" :name="user.id" id="monthCount6" :checked="user.monthCount - user.payedMonthCount==6" style="width:20%;height:1.8em">
                                        <label class="mb-0 mr-2 font-14" for="monthCount6">
                                            6 ماه
                                        </label>
                                    </div>
                                    <div class="col-4 d-flex align-items-center py-2 pr-0" v-if="user.validMonthCount==12">
                                        <input class="m-0" type="radio" @change="changeMonthRadio(12, user)" :name="user.id" id="monthCount12" :checked="user.monthCount - user.payedMonthCount==12" style="width:20%;height:1.8em">
                                        <label class="mb-0 mr-2 font-14" for="monthCount12">
                                            12 ماه
                                        </label>
                                    </div>
                                </div>
                                <!--<div class="row mb-0 pr-3">-->
                                <!--<div class="col-6 d-flex align-items-center py-2 pr-0" v-if="user.validMonthCount>=3">
                                    <input class="m-0" type="radio" @change="changeMonthRadio(3, user)" :name="user.id" id="monthCount3" :checked="user.monthCount - user.payedMonthCount==3" style="width:20%;height:1.8em">
                                    <label class="mb-0 mr-2 font-14" for="monthCount3">
                                        3 ماه
                                    </label>
                                </div>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CreateUser', params: { id: selectedId } }" class="d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-search color-green2-light float-right font-14"></i>
                            ویرایش
                        </span>
                        <i class="fa fa-angle-left"></i>
                    </router-link>
                    <button @click="deleteTaskOnlineUser" class="d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-trash color-red1-light float-right font-14"></i>
                            حذف
                        </span>
                        <i class="fa fa-angle-left"></i>
                    </button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="تشکیل تیم کاری و خرید اشتراک" keyEn="order" v-if="isKarnegasht==true"></Help-Menu>

    </div>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">پیام</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body m-0 pb-0">
                    <div class="my-3" v-html="taskOnlinePayForFreeMessage">

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Button trigger modal -->
    <button type="button" style="display:none" class="btn btn-primary" id="btnShowModal" data-toggle="modal" data-target="#exampleModalCenter">
        Launch demo modal
    </button>
    <!--<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center"><i class="font-22 fa fa-bars"></i></button>-->

</template>

<script>
    import { Browser } from "@capacitor/browser";
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    import { InAppPurchase } from '@ionic-native/in-app-purchase';

    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                user: {},
                searchKey: "",
                selectedId: 0,
                pageLoaded: false,
                loading: false,
                taskOnlinePayForFreeMessage: "",
                pageLoading: true,
                PriceRate: 70000,
                Description: ""
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            orginalpayable() {
                var res1 = (this.user.monthCount - this.user.payedMonthCount) * this.PriceRate * 1.10;
                return res1.toFixed();
            },
            payable() {
                var sum = this.user.unPayedPrice;
                var res = sum * 1.10;
                return res.toFixed();
            },
            descriptionText() {
                return this.Description;
            },
        },

        created() {
            this.GetPriceRate();
            this.GetTaskOnlineItem(true);
            this.$http
                .get("TaskOnline/GetTaskOnlineMessage")
                .then((data) => {
                    this.Description = data.data.description;
                });
            this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
                .then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
                });
        },

        methods: {
            showMenu(id) {
                this.selectedId = id;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            GetPriceRate() {

                this.loading = true;
                this.$http.get("TaskOnline/GetPriceRate").then((data) => {
                    this.loading = false;
                    this.PriceRate = data.data;
                });
            },
            deleteTaskOnlineUser() {
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این کاربر هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.$http
                        .get("TaskOnline/Delete?id=" + this.selectedId)
                        .then((data) => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                document.getElementsByClassName("menu-hider")[0].click();
                                this.GetTaskOnlineItem();
                            } else {
                                this.showErrorMessage(res);
                            }
                        });
                });
            },
            openDetails(id) {
                this.$router.push({ name: "CreateUser", params: { id: id } });
                document.getElementsByClassName("menu-hider")[0].click();
            },
            async sendForPayment() {
                if (this.isFreeVersion) {
                    if (this.taskOnlinePayForFreeMessage != null && this.taskOnlinePayForFreeMessage != "") {
                        var btnShowModal = document.getElementById("btnShowModal");
                        btnShowModal?.click();
                        //this.showErrorMessage(this.taskOnlinePayForFreeMessage);
                        return;
                    }
                }
                if (this.user.disabled) {
                    this.showErrorMessage("اشتراک شما بیش از تاریخ معتبر می باشد و امکان خرید اشتراک برای شما در حال حاضر وجود ندارد زمان دیگیری برای تمدید مراجعه فرمایید");                    return;
                }
                if (this.payable === 0 || this.payable === "0") {
                    return;
                }

                await Browser.open({
                    url:
                        "https://dssnovinit.com/dashboard/BankConnection/TaskOnlinePaymentByPn?p=" +
                        this.user.phoneNumber + "&e=" + this.user.emailAddress,
                });
            },
            async sendForPaymentBazaar() {
                InAppPurchase
                    .restorePurchases()
                    .then(function (data) {
                        console.log(data);
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            },
            changeMonthRadio(val, user) {
                var oldVal = user.monthCount - user.payedMonthCount;
                var c = user.monthCount + (val - oldVal);//تعداد ماهی که داره و تعداد ماهی که قراره بهش اضافه بشه
                var relVal = val - oldVal;//تعداد ماهی که قرارا اضافه بشه
                if (user.payedMonthCount <= c) {
                    this.loading = true;
                    this.pageLoading = true;
                    user.monthCount = c;
                    this.$http
                        .get("TaskOnline/ChangeMonthCount?id=" + user.id + "&val=" + c + "&relVal=" + relVal + "&selectVal=" + val)
                        .then((data) => {
                            this.loading = false;
                            this.pageLoading = false;
                            if (data.data == "1") {
                                this.GetTaskOnlineItem();
                            } else {
                                this.showErrorMessage(data.data);
                            }
                        });
                }
            },
            changeMonth(val, user) {
                var c = user.monthCount + val;
                var relVal = (user.monthCount - user.payedMonthCount + val);
                if (user.payedMonthCount <= c) {
                    this.loading = true;
                    user.monthCount = c;
                    this.$http
                        .get("TaskOnline/ChangeMonthCount?id=" + user.id + "&val=" + c + "&relVal=" + relVal)
                        .then((data) => {
                            this.loading = false;
                            if (data.data == "1") {
                                this.GetTaskOnlineItem();
                            } else {
                                this.showErrorMessage(data);
                            }
                        });
                }
            },
            GetTaskOnlineItem(isLoad = false) {
                this.loading = true;
                this.pageLoading = true;
                this.$http.get("TaskOnline/GetUserbyPhoneNumberForEdit").then((data) => {
                    this.user = data.data;
                    this.pageLoading = false;
                    this.loading = false;
                    if (isLoad) {
                        //this.changeMonthRadio(this.user.monthCount - this.user.payedMonthCount, this.user)
                    }
                });
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },

        },
        mounted() {
            console.log("mounted");
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

        },
    };
</script>
